<template>
  <div class="px-3">
    <div class="is-size-7 columns mb-2 is-vcentered is-mobile">
      <div
        class="column mr-3 has-text-weight-bold is-size-6 is-uppercase pointer"
        @click="openTagList = !openTagList"
      >
        {{ $t('tags') }}
      </div>
      <div class="column is-2" @click="openTagList = !openTagList">
        <vue-icon-base
          v-show="!openTagList"
          class="is-pulled-right pointer"
          height="16"
          width="16"
          :path="$options.icons[$kc('uni-plus-circle')]"
        ></vue-icon-base>
        <vue-icon-base
          v-show="openTagList"
          class="is-pulled-right pointer"
          height="16"
          width="16"
          :path="$options.icons[$kc('uni-minus-circle')]"
        ></vue-icon-base>
      </div>
    </div>
    <div v-if="tagList.length">
      <div v-if="openTagList">
        <div
          v-for="(tag, index) in tagList"
          :key="index"
          class="pointer word-break outline tag is-light ml-1 mt-1 mb-2 mr-2 pa-1 is-uppercase"
          :class="{
            'is-active has-background-grey-lighter': activeTag(tag.slug)
          }"
          @click="displayTagBlog(tag.slug)"
        >
          {{ `${tag.name} (${tag.count})` }}
        </div>
      </div>
    </div>

    <div v-else class="pl-3">
      <vue-no-data :loading="loading"></vue-no-data>
    </div>
  </div>
</template>
<script>
import VueNoData from '@/components/Commons/VueNoData'
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniPlusCircle, uniMinusCircle } from '@/helpers/icons'
export default {
  components: { VueNoData, VueIconBase },
  icons: { uniPlusCircle, uniMinusCircle },
  data() {
    return {
      openTagList: false,
      loading: false
    }
  },
  computed: {
    tagList() {
      return (
        this.get(this.$store.state.collection.collectionResponses, [
          'BlogTagList',
          'tags'
        ]) || []
      )
    }
  },
  mounted() {
    this.getTag()
  },
  methods: {
    getTag() {
      this.loading = true
      const contentUrl = `/api/v1/blogs/by-tags/`
      this.$axios
        .get(contentUrl)
        .then(({ data }) => {
          this.$store.commit('collection/setCollectionData', [
            'BlogTagList',
            data
          ])
        })
        .finally(() => {
          this.loading = false
        })
    },
    activeTag(tagSlug) {
      return (
        this.$route.params.slug === tagSlug &&
        [
          `/en/blog/tag/${this.$route.params.slug}`,
          `/blog/tag/${this.$route.params.slug}`
        ].includes(this.$route.path)
      )
    },
    displayTagBlog(slug) {
      this.$router.push(
        this.localePath({
          name: 'blog-tag-slug',
          params: { slug }
        })
      )
    }
  }
}
</script>
